import { useEffect } from 'react';
import useNavigate from '../utils/router/useNavigate';
import { useLocation } from '../utils/router/v3Bridge';
import type { OnboardingSubject } from './onboardingSlice';
import { OnboardingActions } from './onboardingSlice';
import { useAppDispatch } from '../app/redux/useAppSelector';

const SUBJECT = 'onboardingSubject';
const STEP = 'onboardingStep';

export const useReadOnboardingQueryString = () => {
  const { query: { [SUBJECT]: subject, [STEP]: stepString } = {} } =
    useLocation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (subject && typeof stepString === 'string') {
      dispatch(
        OnboardingActions.setOnboardingData({
          subject: subject as OnboardingSubject,
          step: parseInt(stepString, 10),
        }),
      );
      const url = new URL(window.location.href);
      url.searchParams.delete('onboardingSubject');
      url.searchParams.delete('onboardingStep');
      navigate(window.location.pathname + url.search.replace(/^\?$/, ''), {
        replace: true,
      });
    }
  }, [dispatch, navigate, stepString, subject]);
};

export const getUrlWithOnboardingQueries = (
  subject: OnboardingSubject,
  step: number,
) => {
  const url = new URL(window.location.href);
  url.searchParams.set(SUBJECT, subject);
  url.searchParams.set(STEP, step.toString());

  return `${url.pathname}${url.search}`;
};
